import Modal from "components/ui/Modal";
import React, { useState } from "react";
import { AllowIp } from "./AllowIp";
import { Box, Divider, Grid, OutlinedInput, Typography, ThemeProvider, IconButton } from "@mui/material";
import customThems from "thems/allowIPTheme";
import Button from "components/ui/Button";
import { getIcon } from "utils/iconsConfig";
import { Padding } from "@mui/icons-material";
import { dyanamicIpData } from "./ipData";

export const AddAllowIPModel = ({ open, setOpen, handleSetIp }) => {
  const [tempAllowIp, setTempAllowIp] = useState({
    from_ip: "",
    to_ip: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    const ipRegex = /^[0-9.]*$/;

    if (ipRegex.test(value)) {
      setTempAllowIp((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const findEmptyValue = () => {
    for (let key in tempAllowIp) {
      if (!tempAllowIp[key] || tempAllowIp[key].trim() === "") {
        return true;
      }
    }
    return false;
  };

  const handleSumbit = () => {
    handleSetIp({ newIps: tempAllowIp });
    handleClosed();
  };

  const handleClosed = () => {
    setTempAllowIp({
      from_ip: "",
      to_ip: "",
    });
    setOpen(false);
  };

  const ipData = {
    fromIp: {
      key: "From_IP",
      title: "From IP",
      id: "from_ip",
      name: "from_ip",
      type: "text",
      placeholder: "Enter IP Address",
      onChange: handleChange,
      value: tempAllowIp?.from_ip,
      // isEditUser={id ? true : false}
      gridStyle: { xl: 6, lg: 6, md: 6, sm: 12, xs: 12 },
      readOnly: "false",
    },
    toIp: {
      key: "To_IP",
      title: "To IP",
      id: "to_ip",
      name: "to_ip",
      type: "text",
      placeholder: "Enter IP Address",
      onChange: handleChange,
      value: tempAllowIp?.to_ip,
      // isEditUser={id ? true : false},
      gridStyle: { xl: 6, lg: 6, md: 6, sm: 12, xs: 12 },
      readOnly: "false",
    },
  };
  const handleClose = () => setOpen(false);
  return (
    <>
      <ThemeProvider theme={customThems}>
        <Modal open={open} handleClose={handleClose} style={{ width: "690px", margin: "0px", padding: "0px" }}>
          <Grid container width={"100%"} rowGap="10px" sx={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
            <Grid width={"100%"} item xm={12} sm={12} md={12} lg={12} xl={12} sx={{ paddingTop: "25px", paddingLeft: "25px", paddingRight: "20px" }}>
              <Box sx={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Typography sx={{ color: "#00000", fontFamily: "Poppins", fontSize: "24px", fontWeight: 500, lineHeight: "22px" }}>IP Addresses </Typography>
                <IconButton disableFocusRipple disableRipple sx={{ p: 0 }} onClick={handleClosed}>
                  {getIcon("CrossIcon")}
                </IconButton>
              </Box>
            </Grid>
            <Grid width={"100%"} item xm={12} sm={12} md={12} lg={12} xl={12} sx={{ paddingTop: "10px", paddingLeft: "25px", paddingRight: "20px" }}>
              <Divider
                orientation="horizontal"
                flexItem
                style={{ borderColor: "#8B8B8B", borderWidth: "1px", border: "0.5px solid", opacity: "0.5", width: "100%", marginBottom: "5px", marginTop: "5px" }}
              />
            </Grid>
            <Grid width={"100%"} item xm={12} sm={12} md={12} lg={12} xl={12}>
              <AllowIp ipData={ipData} />
            </Grid>
            <Grid width={"100%"} item xm={12} sm={12} md={12} lg={12} xl={12} sx={{ paddingTop: "5px", paddingBottom: "25px" }}>
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", margin: "5px" }}>
                <Button disabled={findEmptyValue()} onClick={handleSumbit}>
                  Save
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Modal>
      </ThemeProvider>
    </>
  );
};
